<template>
    <div class="timeline-container">
        <div class="line"></div>
        <div v-for="(item, index) in jobTitleSalaries" :key="index" class="timeline-item">
            <div class="left-time green">
                <span class="label">{{ item.start_date }}</span>
            </div>
            <div class="right-title blue">
                <span class="label">{{ item.jobTitle }}</span>
                {{ `${item.amount.amount / 100} ${item.amount.currency}` }}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState({
                jobTitleSalaries: state => state.employeeManager.employee.salaries
            })
        }
    }
</script>

<style scoped>
.timeline-container {
    position: relative;
}

.line {
    width: 10px;
    height: 100%;
    position: absolute;
    top: 0px;
    left: 250px;
    background: #CCC;
    z-index: 5;
}

.timeline-item > div {
    display: inline-block;
}

.left-time {
    padding-right: 20px;
    padding-bottom: 10px;
    width: 250px;
    text-align: right;
}

.right-title {
    padding-left: 20px;
    padding-bottom: 10px;
}

.timeline-item::before {
    content: ' ';
    width: 24px;
    height: 24px;
    background: lightblue;
    border-radius: 50%;
    position: absolute;
    z-index: 10;
    left: 243px;
}

.blue .label,
.blue.timeline-item::before {
    background: #00bcd4;
}

.green .label,
.green.timeline-item::before {
    background: #8bc34a;
}

.label {
    font-size: 12px;
    padding: 2px 6px;
    color: white;
    border-radius: 5px;
}
</style>
